import React from 'react';

export default function BackIcon(props) {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="22px"
      height="22px"
      viewBox="0 -2 10 18"
      style={{ enableBackground: 'new 0 0 12.9 12.7' }}
      xmlSpace="preserve"
      {...props}
    >
      <path
        id="XMLID_1_"
        d="M12.8,5.6H2.6L7.3,1c0,0,0,0,0-0.1s0,0,0-0.1L6.4,0c0,0,0,0-0.1,0s0,0-0.1,0L0,6.3
      	c0,0,0,0.1,0,0.1l6.3,6.3c0,0,0,0,0.1,0s0,0,0.1,0l0.9-0.9c0,0,0,0,0-0.1s0,0,0-0.1L2.6,7h10.2c0,0,0.1,0,0.1-0.1L12.8,5.6
      	C12.9,5.7,12.8,5.6,12.8,5.6z"
      />
    </svg>
  );
}
